import { ChevronLeft } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function MobileSubroute({ title, children }: PropsWithChildren & { title: string }) {
  const nav = useNavigate();
  const { t } = useTranslation();

  return (
    <Stack p={2}>
      <Stack mb={4}>
        <ChevronLeft
          fontSize="large"
          color="primary"
          onClick={() => nav(-1)}
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            cursor: "pointer",
            padding: "10px",
            boxSizing: "content-box",
          }}
        />
        <Typography m="auto" variant={"h6"} color="primary">
          {t(title)}
        </Typography>
      </Stack>
      <Box>{children}</Box>
    </Stack>
  );
}
